import { ProductType } from 'Quotes/types/productTypes';
import { doRequest, Methods } from '../../../Request';
import IQuoteRecordAttributesBase, { IMeta } from '../../types/quoteRecordAttributesBase';
import { OptionalQuoteParams, toQueryParams } from '../getQuote';

type DeepPartial<T> = {
  [K in keyof T]?: DeepPartial<T[K]>;
};

const updateQuote = (quoteId: string, updateValues: DeepPartial<IQuoteRecordAttributesBase>, currentMeta: IMeta, include?: OptionalQuoteParams) => {
  const body: any = {
    data: {
      attributes: {
        ...updateValues,
        meta: {
          ...currentMeta,
          ...updateValues.meta,
        },
      },
      type: 'quote',
    },
  };

  if (body.data.attributes.product_type === ProductType.DIA) {
    delete body.data.attributes.b_end_port;
  }

  const params = toQueryParams(include ?? {});

  return doRequest({
    body,
    method: Methods.PATCH,
    path: `/quotes/${quoteId}${params.length > 0 ? `?include=${params}` : ''}`,
  });
};

export default updateQuote;
